import { createStore } from 'zustand';
const defaultHandler = (error) => {
    console.log('[layerswap:log]', error);
};
const createLogStore = () => {
    return createStore()((set) => ({
        logger: defaultHandler,
        setLogger: (handler) => set({ logger: handler })
    }));
};
export const logStore = createLogStore();
